import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Form, Input, Overlay, Tab, Loading, Affix, Grid } from "@alifd/next";
import { history } from "ice";
import LzMsg from "@/components/common/LzMessage";
import styles from "./index.module.scss";
import { Servlets } from "@/service";
import moment from "moment";
import utils from "@/common/utils";
import TabTag from "./components/tabTag";
import StandardPeopleTagList from "./components/StandardPeopleTagList";
import AudiencePackList from "./components/AudiencePackList";
import CrowdGathering from "./components/crowdGathering";
const { Row, Col } = Grid;
interface CrowdInfo {
  name: string;
  description: string;
}

interface Tag {
  id: string;
  labelName: string;
  labelDescription: string;
  labelType: number;
  opType?: string;
  opValue?: any;
}

interface SelectedCrowdData {
  audienceList: Tag[];
  unionCollectionList: Tag[];
  differenceCollectionList: Tag[];
}
const formItemLayout = {
  labelCol: {
    fixedSpan: 4,
  },
  wrapperCol: {
    span: 18,
  },
};
const CrowdTag: React.FC<{ match: any }> = ({ match }) => {
  const formatDateFun = (value: Date) => {
    const date = new Date(value);
    const format = (num: number) => (num < 10 ? `0${num}` : num);
    return `默认创建${format(date.getMonth() + 1)}月${format(date.getDate())}日${format(date.getHours())}时${format(date.getMinutes())}分${format(date.getSeconds())}秒`;
  };

  const [crowdInfo, setCrowdInfo] = useState<CrowdInfo>({
    name: formatDateFun(new Date()),
    description: moment().format("YYYY MM月DD日创建人群").toString().split(" ")[1],
  });

  const refHandler = useRef<any>(null);
  const backBoxRef = useRef<any>(null);

  const [createSucc, setCreateSucc] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [standardTagList, setStandardTagList] = useState<any[]>([]);
  const [crowdNum, setCrowdNum] = useState("-");
  const [selectedCrowdItemList, setSelectedCrowdItemList] = useState<any[]>([]);
  const [selectedCrowdDataList, setSelectedCrowdDataList] = useState<SelectedCrowdData>({
    audienceList: [],
    unionCollectionList: [],
    differenceCollectionList: [],
  });
  const [selectedActiveListData, setSelectedActiveListData] = useState<SelectedCrowdData>({
    audienceList: [],
    unionCollectionList: [],
    differenceCollectionList: [],
  });
  const [copyList, setCopyList]: any = useState<SelectedCrowdData | any>({
    peopleList: [],
    unionCollectionList: [],
    differenceCollectionList: [],
  });

  const setBreadcrumb = () => {
    utils.setBreadcrumb({
      name: "客户管理",
      url: "/web/CustomerManagement",
      children: {
        name: "人群管理",
        url: "/web/CustomerManagement",
        children: {
          name: "标签组合",
          url: "",
        },
      },
    });
  };

  const getTags = async () => {
    const res: any = await Servlets("getPublicPeopleTag", {});
    if (res.success) {
      const data = res.data.tab_list;
      setStandardTagList(data);
      data.forEach((i1: any) => {
        i1.labelName = i1?.tab_name;
        i1.labelDescription = i1?.tab_name;
        i1.crowdLabels =
          i1.sub_tab.length > 0
            ? i1.sub_tab.map((i2: any) => ({
                labelName: i2?.tab_name,
                labelDescription: i2?.tab_name,
                crowdLabels: i2?.label_list?.map((i3: any) => ({
                  id: i3?.label_id,
                  labelName: i3?.label_name,
                  labelDescription: i3?.label_name,
                  label_desc: i3?.label_desc,
                  labelType: i3?.label_type,
                  valueType: i3?.label_type,
                  value: i3?.param_list?.map((i4: any) => ({
                    realValue: i4?.param_id,
                    fieldValue: i4?.param_name,
                    ...i4,
                  })),
                })),
              }))
            : [
                {
                  labelName: i1?.tab_name,
                  labelDescription: i1?.tab_name,
                  crowdLabels: i1?.label_list?.map((i2: any) => ({
                    labelName: i2?.label_name,
                    labelDescription: i2?.label_name,
                    crowdLabels: i1?.label_list?.map((i3: any) => ({
                      id: i3?.label_id,
                      labelName: i3?.label_name,
                      labelDescription: i3?.label_name,
                      label_desc: i3?.label_desc,
                      labelType: i3?.label_type,
                      valueType: i3?.label_type,
                      value: i3?.param_list?.map((i4: any) => ({
                        realValue: i4?.param_id,
                        fieldValue: i4?.param_name,
                      })),
                    })),
                  })),
                },
              ];
      });
      setIsLoading(false);
    } else {
      setIsLoading(false);
      LzMsg.error(res.resp_msg);
    }
  };

  const [officeCrowdInfo, setOfficeCrowdInfo] = useState<any[]>([]);
  const [diyCrowdInfo, setDiyCrowdInfo] = useState<any[]>([]);
  const [currentShowCrowdInfo, setCurrentShowCrowdInfo] = useState<any[]>([]);

  let allSelectNum = 0;
  const isArray = (obj: any) => Array.isArray(obj);
  const numFun = (source: any) => {
    source.forEach((item: any) => {
      if (isArray(item.crowdLabels)) {
        numFun(item.crowdLabels);
      } else {
        allSelectNum += 1;
      }
    });
  };

  const standardTagChange = (item: any) => {
    setSelectedCrowdItemList(item.sub_tab);
  };

  const standardCrowdList = async (item: any) => {
    clickCrowdLeftGroup(item.id);
  };

  const clickCrowdLeftGroup = (key: number) => {
    setCurrentShowCrowdInfo(key === 0 ? [...officeCrowdInfo] : [...diyCrowdInfo]);
  };

  const createFun = async () => {
    try {
      const bodyParam = checkNewFun();
      setIsLoading(true);
      const res: any = await Servlets("newcreateCrowd", bodyParam);
      if (res.success) {
        setTimeout(() => {
          history.push("/CustomerManagement");
        }, 3000);
        setCreateSucc(true);
      } else {
        LzMsg.error(res.resp_msg);
      }
    } catch (e: any) {
      LzMsg.error(e.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getCrowds = async () => {
    const officeRes: any = await Servlets("getDYCrowdList", { pageNo: 1, pageSize: 99999, type: 3 });
    if (officeRes.success) {
      setOfficeCrowdInfo(officeRes.data);
      setCurrentShowCrowdInfo(officeRes.data);
    } else {
      LzMsg.error(officeRes.resp_msg);
    }

    const diyRes: any = await Servlets("getDYCrowdList", { pageNo: 1, pageSize: 99999, type: "1,2,5,6,8,9,10", crowdStatus: 1 });
    if (diyRes.success) {
      setDiyCrowdInfo(diyRes.data);
    } else {
      LzMsg.error(diyRes.resp_msg);
    }
  };

  const estimateFun = async () => {
    try {
      const bodyParam = checkNewFun();
      setIsLoading(true);
      const res: any = await Servlets("newprecalculate", bodyParam);
      setCrowdNum(res.success ? res.data : "-");
    } catch (e: any) {
      LzMsg.error(e.message);
    } finally {
      setIsLoading(false);
    }
  };

  const checkNewFun = () => {
    const audienceList = [...selectedActiveListData.audienceList, ...selectedCrowdDataList.audienceList];
    const unionCollectionList = [...selectedActiveListData.unionCollectionList, ...selectedCrowdDataList.unionCollectionList];
    const audienceIntersectionList = [...selectedActiveListData.differenceCollectionList, ...selectedCrowdDataList.differenceCollectionList];

    if (audienceList.length === 0 && unionCollectionList.length === 0) {
      throw new Error("交集与并集至少需存在一个标签");
    }

    if (!crowdInfo.name) {
      throw new Error("人群名称不能为空");
    }

    const bodyParam = {
      peopleName: crowdInfo.name,
      peopleDescription: crowdInfo.description,
      mergeType: 0,
      peopleList: checkCrowdData(audienceList, "交集"),
      unionCollectionList: checkCrowdData(unionCollectionList, "并集"),
      differenceCollectionList: checkCrowdData(audienceIntersectionList, "差集"),
    };
    return bodyParam;
  };

  const checkCrowdData = (list: Tag[] | any, name: string) => {
    return list.map((subItem: Tag | any) => {
      if (subItem.crowdId) {
        return {
          id: subItem.id,
          labelName: subItem.name,
          labelDescription: subItem.description,
          labelType: 8,
          opValue: {
            label_id: "46",
            extra_map: {
              source_audience_id: subItem.crowdId,
              source_audience_name: subItem.name,
              source_audience_desc: subItem.description,
            },
          },
        };
      } else if (subItem?.opValue) {
        const { labelType, opType, opValue, labelDescription }: any = subItem;
        if (labelType === "1" && !opValue?.param_list[0]?.param_id) throw new Error(`${name}${labelDescription}标签不能为空`);
        if (labelType === "2" && !opValue?.param_list[0]?.param_id) throw new Error(`${name}${labelDescription}标签不能为空`);
        if (labelType === "3" && !opValue?.param_list?.length) throw new Error(`${name}${labelDescription}标签不能为空`);
        if (labelType === "4" && !opValue?.extra_map[0]?.slider) throw new Error(`${name}${labelDescription}标签不能为空`);
        if (labelType === "5" && !opValue?.param_list?.length) throw new Error(`${name}${labelDescription}标签不能为空`);
        if (labelType === "5" && opType === "RANGE" && !opValue?.extra_map?.max_price) throw new Error(`${name}${labelDescription}标签不能为空`);
        if (labelType === "5" && opType === "RANGE" && !opValue?.extra_map?.min_price) throw new Error(`${name}${labelDescription}标签不能为空`);
        if (labelType === "5" && opType !== "RANGE" && !opValue?.extra_map?.price) throw new Error(`${name}${labelDescription}标签不能为空`);
        if (labelType === "5" && Number(opValue?.extra_map?.max_price) < Number(opValue?.extra_map?.min_price)) throw new Error(`${name}${labelDescription}标签范围填写有误`);
        if (labelType === "6" && (!opValue?.extra_map || !opValue?.extra_map?.date?.length)) throw new Error(`${name}${labelDescription}标签范围填写有误`);
        if (labelType === "6" && opValue?.extra_map?.date?.every((item: any) => !item)) throw new Error(`${name}${labelDescription}标签范围填写有误`);
        if (labelType === "6" && Number(opValue?.extra_map?.date[1]) < Number(opValue?.extra_map?.date[0])) throw new Error(`${name}${labelDescription}标签范围填写有误`);
        if (labelType === "7" && !opValue?.param_list?.length) throw new Error(`${name}${labelDescription}标签不能为空`);
        if (labelType === "8" && !opValue?.extra_map?.source_audience_id) throw new Error(`${name}${labelDescription}标签不能为空`);
        if (labelType === "9" && !opValue?.param_list[0]?.param_id?.length) throw new Error(`${name}${labelDescription}标签不能为空`);
        if (labelType === "9" && !opValue?.param_list[0]?.sub_param_list?.length) throw new Error(`${name}${labelDescription}标签不能为空`);

        return {
          id: subItem.id,
          labelName: subItem.labelName,
          labelType: subItem.labelType,
          labelDescription: subItem.labelDescription,
          opType: subItem.opType,
          opValue: subItem.opValue,
        };
      } else {
        throw new Error(`${subItem.labelDescription}标签不能为空`);
      }
    });
  };

  const isCopy = (standardList: any[], divList: any[]) => {
    if (match.path === "/crowd/newtag/copy") {
      const crowdData = JSON.parse(sessionStorage.getItem("LzCrowdEsIson") || "{}")?.list;
      const copyData: any = {
        peopleList: [],
        unionCollectionList: [],
        differenceCollectionList: [],
      };
      standardList.forEach((element: any) => {
        crowdData?.peopleList.forEach((item: any) => {
          if (element.label_id === item.id) {
            copyData.peopleList.push({ ...element, ...item });
          }
        });
        crowdData?.unionCollectionList.forEach((item: any) => {
          if (element.label_id === item.id) {
            copyData.unionCollectionList.push({ ...element, ...item });
          }
        });
        crowdData?.differenceCollectionList.forEach((item: any) => {
          if (element.label_id === item.id) {
            copyData.differenceCollectionList.push({ ...element, ...item });
          }
        });
      });
      divList.forEach((element: any) => {
        crowdData?.peopleList.forEach((item: any) => {
          if (element.id === item.id) {
            copyData.peopleList.push({ ...element, ...item });
          }
        });
        crowdData?.unionCollectionList.forEach((item: any) => {
          if (element.id === item.id) {
            copyData.unionCollectionList.push({ ...element, ...item });
          }
        });
        crowdData?.differenceCollectionList.forEach((item: any) => {
          if (element.id === item.id) {
            copyData.differenceCollectionList.push({ ...element, ...item });
          }
        });
      });
      setCopyList(copyData);
    } else {
      sessionStorage.removeItem("LzCrowdEsIson");
    }
  };

  useEffect(() => {
    setBreadcrumb();
    getTags();
    getCrowds();
  }, []);

  useEffect(() => {
    const divList = [...officeCrowdInfo, ...diyCrowdInfo];
    if (standardTagList.length > 0 && divList.length > 0) {
      const standardList = standardTagList.map((item: any) => item.sub_tab.map((item: any) => item.label_list)).flat(Infinity);
      isCopy(standardList, divList);
    }
  }, [standardTagList, officeCrowdInfo, diyCrowdInfo]);

  return (
    <div className={`${styles["tag-div"]}`} ref={refHandler}>
    <div className={`${styles["form-box"]}`}>
        <Form labelAlign="left" {...formItemLayout} colon inline>
          <Row gutter="4">
            <Col>
              <Form.Item label="人群名称" {...formItemLayout} labelAlign="left" colon>
                <Input name="人群名称" size="small" maxLength={32} value={crowdInfo.name} onChange={(name: any) => setCrowdInfo({ ...crowdInfo, name })} style={{ width: "350px" }} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="人群描述" {...formItemLayout} labelAlign="left" colon>
                <Input
                  name="描述"
                  size="small"
                  maxLength={32}
                  value={crowdInfo.description}
                  onChange={(description: any) => setCrowdInfo({ ...crowdInfo, description })}
                  style={{ width: "350px" }}
                />
              </Form.Item>
            </Col>
            <Col>
              <span style={{ width: "100px", lineHeight: "32px" }}>
                总人数:<b>{crowdNum}</b>人{" "}
                <Button type="primary" text onClick={estimateFun}>
                  点击计算
                </Button>
              </span>
            </Col>
            <Col span={3}>
              <Form.Item
                style={{
                  justifyContent: "flex-end",
                  whiteSpace: "nowrap",
                  textAlign: "right",
                }}
              >
                <div>
                  <Button type="primary" className={`${styles.w88} ${styles.mr10}`} onClick={createFun}>
                    保存人群
                  </Button>
                  <Button
                    type="normal"
                    className={`${styles.w88}`}
                    onClick={() => {
                      history.push("/CustomerManagement");
                    }}
                  >
                    返回
                  </Button>
                </div>
              </Form.Item>
            </Col>
          </Row>
        </Form>
    </div>

    <div className={`${styles["back-box"]} ${styles["content-container"]} ${styles["flex-between-center"]}`} ref={backBoxRef}>
     <Affix container={()=>backBoxRef.current}>
     <div className={`${styles["label-choose"]} middle-div`}>
        <Tab>
          <Tab.Item title="标签选择" key="0">
            <div style={{ display: "flex", width: "100%", height: "100%", flexDirection: "column" }}>
              <TabTag onChange={(item) => standardTagChange(item)} children={standardTagList}></TabTag>
              <StandardPeopleTagList list={selectedCrowdItemList} />
            </div>
          </Tab.Item>

          <Tab.Item title="人群包选择" key="1">
            <div style={{ display: "flex", width: "100%", height: "100%", flexDirection: "column" }}>
              <TabTag
                onChange={(item) => standardCrowdList(item)}
                children={[
                  { tab_name: "官方人群", id: 0 },
                  { tab_name: "自定义人群", id: 1 },
                ]}
              />
              <AudiencePackList list={currentShowCrowdInfo} selectedCrowdDataList={selectedCrowdDataList} />
            </div>
          </Tab.Item>
        </Tab>
      </div>
      </Affix>


      <div className={styles.crowdGatherings} >

      {/* <div className={` middle-div`}>
      <Tab>
          <Tab.Item title="交集" key="1">
          <CrowdGathering
          title={"交集"}
          desc={"取同时具备以下特征的人群"}
          list={copyList.peopleList}
          changeActiveListData={(audienceList) => {
            setSelectedActiveListData({ ...selectedActiveListData, audienceList });
            selectedActiveListData.audienceList = audienceList;
          }}
          changeCrowdListData={(audienceList) => {
            setSelectedCrowdDataList({ ...selectedCrowdDataList, audienceList });
            selectedCrowdDataList.audienceList = audienceList;
          }}
        />
          </Tab.Item>
          <Tab.Item title="并集" key="2">
          <CrowdGathering
          title={"并集"}
          desc="取具备以下任一特征的人群"
          list={copyList.unionCollectionList}
          changeActiveListData={(unionCollectionList) => {
            setSelectedActiveListData({ ...selectedActiveListData, unionCollectionList });
            selectedActiveListData.unionCollectionList = unionCollectionList;
          }}
          changeCrowdListData={(unionCollectionList) => {
            setSelectedCrowdDataList({ ...selectedCrowdDataList, unionCollectionList });
            selectedCrowdDataList.unionCollectionList = unionCollectionList;
          }}
        />
          </Tab.Item>
          <Tab.Item title="排除" key="4">
          <CrowdGathering
          title={"排除"}
          desc="排除具备以下任一特征的人群"
          list={copyList.differenceCollectionList}
          changeActiveListData={(differenceCollectionList) => {
            setSelectedActiveListData({ ...selectedActiveListData, differenceCollectionList });
            selectedActiveListData.differenceCollectionList = differenceCollectionList;
          }}
          changeCrowdListData={(differenceCollectionList) => {
            setSelectedCrowdDataList({ ...selectedCrowdDataList, differenceCollectionList });
            selectedCrowdDataList.differenceCollectionList = differenceCollectionList;
          }}
        />
          </Tab.Item>
          </Tab>
        </div> */}
        <CrowdGathering
          title={"交集"}
          desc={"取同时具备以下特征的人群"}
          list={copyList.peopleList}
          changeActiveListData={(audienceList) => {
            setSelectedActiveListData({ ...selectedActiveListData, audienceList });
            selectedActiveListData.audienceList = audienceList;
          }}
          changeCrowdListData={(audienceList) => {
            setSelectedCrowdDataList({ ...selectedCrowdDataList, audienceList });
            selectedCrowdDataList.audienceList = audienceList;
          }}
        />
        <CrowdGathering
          title={"并集"}
          desc="取具备以下任一特征的人群"
          list={copyList.unionCollectionList}
          changeActiveListData={(unionCollectionList) => {
            setSelectedActiveListData({ ...selectedActiveListData, unionCollectionList });
            selectedActiveListData.unionCollectionList = unionCollectionList;
          }}
          changeCrowdListData={(unionCollectionList) => {
            setSelectedCrowdDataList({ ...selectedCrowdDataList, unionCollectionList });
            selectedCrowdDataList.unionCollectionList = unionCollectionList;
          }}
        />
        <CrowdGathering
          title={"排除"}
          desc="排除具备以下任一特征的人群"
          list={copyList.differenceCollectionList}
          changeActiveListData={(differenceCollectionList) => {
            setSelectedActiveListData({ ...selectedActiveListData, differenceCollectionList });
            selectedActiveListData.differenceCollectionList = differenceCollectionList;
          }}
          changeCrowdListData={(differenceCollectionList) => {
            setSelectedCrowdDataList({ ...selectedCrowdDataList, differenceCollectionList });
            selectedCrowdDataList.differenceCollectionList = differenceCollectionList;
          }}
        />
      </div>
    </div>
    <Overlay visible={createSucc} align="cc cc" hasMask disableScroll canCloseByMask={false}>
    <span className="overlay-demo">创建人群成功，即将跳转人群管理页面</span>
  </Overlay>
  <Loading visible={isLoading} fullScreen />
  </div>

  );
};
export default CrowdTag;
